// extracted by mini-css-extract-plugin
export default {"marginSummary":"MarginSummary_marginSummary__p8ZpL"};